import React, { useEffect, useState } from 'react'
import { ROUTES } from '@sportninja/common/constants/app'
import { t } from '@sportninja/common/i18n'
import { ENTITY_TYPES } from '@sportninja/common/sagas/utils'

import { RECENTS_KEY_NAME } from '../utils'
import HomeSidebarRecent from './HomeSidebarRecent'
import { SidebarHeader, SidebarInner, SidebarWrap } from './SidebarComponents'
import HomeSidebarNewPost from './HomeSidebarNewPost'
import { useMobxStore } from 'src/state'
import { observer } from 'mobx-react-lite'

const HomeSidebar = observer(({ user, refreshFeed }) => {
  const [recents, setRecents] = useState({})
  const {
    me: {
      state: { account },
    },
  } = useMobxStore()

  useEffect(() => {
    try {
      const jsonFromStorage = localStorage.getItem(RECENTS_KEY_NAME)
      if (jsonFromStorage) {
        const object = JSON.parse(jsonFromStorage)
        if (object?.uid === user.id) {
          setRecents(object)
        } else {
          localStorage.removeItem(RECENTS_KEY_NAME)
        }
      }
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }, [])

  return (
    <SidebarWrap>
      <SidebarInner>
        <SidebarHeader
          imageId={user?.imageId}
          name={user?.fullName}
          subTitle='View profile'
          to={ROUTES.PROFILE.ROOT}
        />
        <HomeSidebarNewPost refreshFeed={refreshFeed} />
        {account?.organization?.name && account?.organization?.url && (
          <HomeSidebarRecent
            type='Your League/Organization'
            iconName='users'
            hideDefaultTitle
            seeMoreRoute={ROUTES.ORGS.ROOT}
            baseRoute={ROUTES.ORG_ROOT}
            recents={[
              {
                id: account?.organization?.url.split('/').pop(),
                fullName: account?.organization?.name,
                imageId: account?.organization?.image,
              },
            ]}
          />
        )}
        {recents[ENTITY_TYPES.org] &&
          recents[ENTITY_TYPES.org].filter(
            (item) => item.id !== account?.organization?.url.split('/').pop()
          ).length > 0 && (
            <HomeSidebarRecent
              type={t('common:organization')}
              iconName='users'
              seeMoreRoute={ROUTES.ORGS.ROOT}
              baseRoute={ROUTES.ORG_ROOT}
              recents={recents[ENTITY_TYPES.org].filter(
                (item) =>
                  item.id !== account?.organization?.url.split('/').pop()
              )}
            />
          )}
        {recents[ENTITY_TYPES.schedule] &&
          recents[ENTITY_TYPES.schedule]?.length > 0 && (
            <HomeSidebarRecent
              type={t('common:competition')}
              iconName='calendar-alt'
              seeMoreRoute={ROUTES.SCHEDULES.ROOT}
              baseRoute={ROUTES.SCHEDULE_ROOT}
              recents={recents[ENTITY_TYPES.schedule]}
            />
          )}
        {recents[ENTITY_TYPES.team] &&
          recents[ENTITY_TYPES.team]?.length > 0 && (
            <HomeSidebarRecent
              type={t('common:team')}
              iconName='user-friends'
              seeMoreRoute={ROUTES.TEAMS.ROOT}
              baseRoute={ROUTES.TEAM_ROOT}
              recents={recents[ENTITY_TYPES.team]}
            />
          )}
      </SidebarInner>
    </SidebarWrap>
  )
})

export default HomeSidebar
